import {Helmet} from 'react-helmet'

export default function ServicesPageTitle({
  title = 'Kensho Services',
  description = 'Usage info and payment history for Kensho APIs',
}): JSX.Element {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  )
}
